import React from 'react';

/**
 * Error boundary for Intelligence-Layer components.
 * Catches render errors in analytics, signal, similarity, and action components
 * so they degrade gracefully without crashing the CRM.
 */
class IntelligenceErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidUpdate(prevProps) {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false });
    }
  }

  componentDidCatch(error, info) {
    console.warn(
      `[IntelligenceErrorBoundary] ${this.props.label || 'component'} crashed:`,
      error?.message,
      info?.componentStack?.split('\n')[1]?.trim()
    );
    if (this.props.onError) this.props.onError(error);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.silent) return null;

      return (
        <div style={{
          padding: '8px 12px',
          fontSize: '12px',
          color: '#94a3b8',
          textAlign: 'center',
        }}>
          {this.props.fallbackText || 'Intelligence temporarily unavailable'}
        </div>
      );
    }

    return this.props.children;
  }
}

export default IntelligenceErrorBoundary;
